module.exports = __webpack_public_path__ + "img/digital07.cec0efb4.jpg";